import React, { useState } from "react";
import styled from "styled-components";
import fontSize from "../../theme/fonts/FontTheme";
import { HiOutlineArrowSmallRight } from "react-icons/hi2";
import colors from "../../theme/color/ColorTheme";

// ===== Styled Components =====
const Wrapper = styled.div`
  width: 300px;

  @media (max-width: 950px) {
    width: 100%;
  }
`;

const Container = styled.div`
  letter-spacing: 1px;
  display: flex;
  gap: 8px;
  flex-direction: column;
  justify-content: space-between;
`;

const Header = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;

  @media (max-width: 950px) {
    text-align: center;
  }
`;

const Title = styled.div``;

const SubTitle = styled.div`
  line-height: 15px;
  font-size: ${fontSize.xxs};
`;

const InputWrapper = styled.div`
  position: relative;
  width: 300px;

  @media (max-width: 950px) {
    width: 100%;
  }
`;

const Input = styled.input`
  width: 100%;
  border: none;
  padding: 8px 0px; /* padding right for icon */
  background-color: transparent;
  border-bottom: 1px solid black;
  caret-color: black;

  &::placeholder {
    color: black;
  }

  &:focus {
    outline: none;
  }
`;

const Icon = styled(HiOutlineArrowSmallRight)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: black;
  height: 20px;
  width: 20px;
`;

const Consent = styled.div`
  font-size: 10px;
  line-height: 15px;
`;

const Message = styled.div`
  font-size: 12px;
  color: ${({ type }) => (type === "error" ? "#d11609" : colors.maroon)};
  margin-top: 4px;
`;

// ===== Component =====
function SubscibeToNewsletterCard() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [type, setType] = useState("");

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = () => {
    if (!email) {
      setMessage("Email cannot be empty.");
      setType("error");
      return;
    }
    if (!validateEmail(email)) {
      setMessage("Invalid email format.");
      setType("error");
      return;
    }

    setMessage("Thank you for subscribing!");
    setType("success");
    setEmail("");
  };

  return (
    <Wrapper>
      <Container>
        <Header>
          <Title>Subscribe to our newsletter</Title>
          <SubTitle>
            Receive our newsletter and discover our world, collections and
            latest news from us.
          </SubTitle>
        </Header>

        <InputWrapper>
          <Input
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          />
          <Icon onClick={handleSubmit} />
        </InputWrapper>

        {message && <Message type={type}>{message}</Message>}

        <Consent>
          I acknowledge that my email address will be processed by Peak Pashmina
          in accordance with the provisions of the Privacy Policy
        </Consent>
      </Container>
    </Wrapper>
  );
}

export default SubscibeToNewsletterCard;
